import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { ProviderCrudService } from 'src/app/shared/services/provider-crud.service';
import { Provider } from 'src/app/shared/interfaces/provider';

@Component({
  selector: 'app-providers',
  templateUrl: './providers.component.html',
  styleUrls: ['./providers.component.scss']
})
export class ProvidersComponent implements OnInit {

  providers: Provider[];
  provider: Provider;
  selectedProviders: Provider[] = [];

  providerDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private providerService : ProviderCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Providers'}
    ];

    this.providers = [];
    this.provider = { } as Provider ;
  }

  ngOnInit(): void {
    
    this.isFilter = false;

    this.dataState();
    let s = this.providerService.getProvidersList(); 
    s.snapshotChanges().subscribe(data => {
      this.providers = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Provider = jsonItem as Provider;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.providers.push(l);
        }
      })
    })

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'tags');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');


    // Exports
    //this.exportColumns = this.cols.map(col => ({title: col.header, dataKey: col.field}));
    this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};

    } );
  }

  dataState() {     
    this.providerService.getProvidersList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    console.log( 'includesCol ', c);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.providers);
            doc.save('providers.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.providers);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "providers");
    });
  }

  exportDTCSV() {
    console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => exportCols.push(sc.field));
    this.exportService.exportToCsv(this.selectedProviders, 'providers', exportCols);
    // this.exportService.exportToCsv(this.providers, 'providers', ['title', 'description', '$key', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.provider = {} as Provider;
    this.submitted = false;
    this.providerDialog = true;
  }

  deleteSelectedProviders() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected providers?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.providers = this.providers.filter(val => !this.selectedProviders.includes(val));
          this.selectedProviders = [];
          this.selectedProviders.forEach( provider => this.providerService.deleteProvider(provider.$key));
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Providers Deleted', life: 3000});
        }
    });
  }

  editProvider(provider: Provider) {
    this.provider = {...provider};
    this.providerDialog = true;
  }

  deleteProvider(provider: Provider) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + provider.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.providers = this.providers.filter(val => val.$key !== provider.$key);
            this.provider = {} as Provider;
            this.providerService.deleteProvider(provider.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Provider Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.providerDialog = false;
    this.submitted = false;
  }

  saveProvider() {
    this.submitted = true;
    if ( this.provider.name.trim() ) {
      if (this.provider.$key) {
          this.providers[this.findIndexById(this.provider.$key)] = this.provider;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Provider Updated', life: 3000});
          this.providerService.updateProvider(this.provider);
        } else {
          this.provider.position = this.providers.length;
          this.providerService.addProvider(this.provider);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Provider Created', life: 3000});
      this.providers = [...this.providers];
    }
    this.providerDialog = false;
    this.provider = { } as Provider;    
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.providers.length; i++) {
        if (this.providers[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeProvider(provider : Provider) {
    this.providerService.updateProvider(provider);
  }


  // Ordering
  completePosition(provider : Provider) {
    if ( this.newPosition > -1 ) {
        provider.position = this.newPosition;
        provider = this.checkPositionLimits(provider);
        this.reorderElements(provider);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.providers.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.providers.length - 1 - event.dropIndex;
    const providerToMove = this.providers[startIndex];

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.providers[index] = this.providers[index+1];
        this.providers[index].position = index;
        this.providerService.updateProvider(this.providers[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.providers[index] = this.providers[index-1];
        this.providers[index].position = index;
        this.providerService.updateProvider(this.providers[index]);
      }
    } 
    this.providers[endIndex] = providerToMove;
    this.providers[endIndex].position = endIndex;
    this.providerService.updateProvider(this.providers[endIndex]);
  }

  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.providers.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, provider: Provider) {
    if (provider.position != null && provider.position > -1) {
      this.previousPosition = provider.position;
      this.newPosition = event;
    }
  }

  checkPositionLimits(provider: Provider) {
    if (!provider.position) {
      return this.provider;
    }
    if (provider.position < 0) {
      provider.position = 0;
      return provider;
    }
    if (provider.position > this.providers.length) {
      provider.position = this.providers.length - 1;
      return provider;
    }
    return provider;
  }

  async reorderElements(provider: Provider) {
    this.newPosition = this.newPosition  > this.providers.length ? this.providers.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === provider.position ) {
      return;
    }
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const providerToMove = this.providers[startIndex];
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        this.providers[index] = this.providers[index+1];
        this.providers[index].position = index;
        this.providerService.updateProvider(this.providers[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.providers[index] = this.providers[index-1];
        this.providers[index].position = index;
        this.providerService.updateProvider(this.providers[index]);
      }
    } 
    this.providers[endIndex] = providerToMove;
    this.providers[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.providerService.updateProvider(this.providers[endIndex]);
    
  }


}
